import React from 'react';
import { FaStar } from 'react-icons/fa';
import './review.css'; // Assuming the CSS is the same as the final version

const ReviewSection = () => {
    
    // Updated reviews focusing on speed, transparency, and financial relief
    const reviews = [
        {
            name: "Priya Sharma",
            designation: "Entrepreneur, Noida",
            rating: 5,
            // Content focus: Business growth and fast funding
            comment: "I needed immediate funding for business expansion. The entire process, from application to disbursement, was completed within hours. Their speed and transparency are commendable.",
            accent: "review-accent-green"
        },
        {
            name: "Rahul Kumar",
            designation: "Marketing Manager, Mumbai",
            rating: 5,
            // Content focus: Transparency and ethical terms
            comment: "I checked multiple platforms, but nowhere did I find terms as clear and simple as theirs. Zero hidden fees gave me complete trust in their service.",
            accent: "review-accent-magenta"
        },
        {
            name: "Anjali Mehta",
            designation: "IT Consultant, Hyderabad",
            rating: 5,
            // Content focus: Digital experience and quick relief from emergency
            comment: "This app proved to be a lifesaver during a medical emergency. The digital process was so easy, I didn't even need to leave home. Truly 5-star service!",
            accent: "review-accent-dark"
        },
    ];

    const renderStars = (rating) => {
        // Star rendering uses the accent color dynamically via CSS variable
        return Array(5).fill(0).map((_, i) => (
            <FaStar 
                key={i} 
                className={i < rating ? 'star-filled' : 'star-empty'} 
            />
        ));
    };

    return (
        <section className="review-section">
            <div className="container review-container">
                
                  <h2 className="trust-section-heading">
                    User Trust,<span className="accent-green-mv">Built</span> <span className="accent-magenta-mv">on</span> Transparency
                </h2>
                <p className="review-subtitle">
                    Unwavering faith built on speed, clear terms, and ethical lending practices across India.
                </p>
                
                <div className="review-grid">
                    {reviews.map((review, index) => (
                        <div 
                            className={`review-card ${review.accent}`} 
                            key={index}
                        >
                            <div className="rating-stars">
                                {renderStars(review.rating)}
                            </div>

                            <p className="review-comment">"{review.comment}"</p>
                            
                            <div className="reviewer-info">
                                <h4 className="reviewer-name">{review.name}</h4>
                                <p className="reviewer-designation">{review.designation}</p>
                            </div>
                            
                            {/* Accent Glow/Element */}
                            <div className="review-accent-bar"></div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ReviewSection;